import { ProductsParametersApi } from '../types/api/products-parameters-api';
import { BaseRouteProps } from '../types/route-props';
import { buildURL, isV3 } from '../common';
import { Method, callAxios } from '../axios';
import { getBrandName } from '../locale';

const getTranslationURL = (contextRoot, countryCode, languageCode) => {
  if (process.env.REACT_APP_DEV === 'mock') return 'http://localhost:3100/get-products-parameters';
  const brand = getBrandName();
  if (isV3()) {
    return buildURL({
      host: process.env.API_HOST,
      endpoint: `/products-comparison/characteristics?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}`,
    });
  }

  return buildURL({
    host: process.env.API_HOST,
    contextRoot,
    countryCode,
    languageCode,
    endpoint: '/product/api/products/comparison/characteristics',
  });
};

export const productsParametersApiFetchers = {
  getProductsParametersFetcher: async ({
    contextRoot,
    countryCode,
    languageCode,
    params,
  }: BaseRouteProps & {
    params: ProductsParametersApi.GetProductsParametersParams;
  }) => {
    const GET_PRODUCTS_PARAMETERS_URL = getTranslationURL(contextRoot, countryCode, languageCode);
    const response = await callAxios<{
      params: typeof params;
      response: ProductsParametersApi.GetProductsParametersResponse;
    }>({
      method: Method.GET,
      url: GET_PRODUCTS_PARAMETERS_URL,
      params,
    });

    return response.data;
  },
};
